import { Label } from 'firebaseFunctions/types'

export const mockLabelA: Label = {
}
